import { render, staticRenderFns } from "./PageBuilder.vue?vue&type=template&id=4d6a0847&scoped=true&"
import script from "./PageBuilder.vue?vue&type=script&lang=ts&"
export * from "./PageBuilder.vue?vue&type=script&lang=ts&"
import style0 from "./PageBuilder.vue?vue&type=style&index=0&id=4d6a0847&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6a0847",
  null
  
)

export default component.exports